export default {
	lang: 'ja',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'アカウントセキュリティ',
		"nav1": 'マイクラウドディスク',
		"nav2": 'ログアウト',
		"nav3": 'ログイン/登録',
		"nav4": '通話や音声コンテンツを録音し、テキストに変換できます。使用するには、VTransBUDSシリーズのヘッドホンを接続する必要があります。',
		"nav5": 'ダウンロードするにはコードをスキャンしてください',
		"nav6": '重要なコミュニケーション、効率的なバックトラッキング',
		"speaker_not_null": 'スピーカーが空のため編集できません！',
		"speaker": 'スピーカー',
		"copy_success": 'コピーに成功しました',
	},
	login: {
		"login1": 'パスワードログイン',
		"login2": 'SMSログイン',
		"loginTab3": 'メールログイン',
		"login3": 'メールアドレス',
		"login4": 'ログインパスワード',
		"login5": '携帯電話番号',
		"login6": '選択してください',
		"login7": '携帯電話認証コード',
		"login8": 'ログイン',
		"login9": 'パスワードを忘れた場合',
		"login10": '登録',
		"login11": 'ログインすると同意したものとみなされます',
		"login12": 'サービス規約',
		"login13": 'プライバシーポリシー',
		"login14": '取得',
		"login15": '中国',
		"login16": 'アカウントを入力してください',
		"login17": 'パスワード',
		"login18": 'ログイン成功！',
		"login19": '確認コードを入力してください！',
		"login20": '送信成功！',
		"login21": 'そして',
		"login22": 'レコーダークラウドディスク',
		"login23": '私の書き込み',
		"login24": '私の会話',
		"login25": 'アカウントセキュリティ',
		"login26": 'ログアウト',
		"login27": 'メールパスワードの取得',
		"login28": 'メールアドレス',
		"login29": 'メール確認コード',
		"login30": 'ログインパスワードを設定（6～16文字）',
		"login31": 'ログインパスワードをもう一度入力',
		"login32": '送信',
		"login33": '戻るログイン',
		"login34": '変更に成功しました!',
	},
	register: {
		"register1": '携帯電話番号',
		"register2": '携帯電話番号を入力してください',
		"register3": '選択してください',
		"register4": '携帯電話認証コード',
		"register5": 'パスワードを設定',
		"register6": '認証コードを入力してください',
		"register7": '6～16文字',
		"register8": 'パスワードの確認',
		"register9": 'メールアドレス',
		"register10": 'メールアドレスを入力してください',
		"register11": 'メール認証コード',
		"register12": '認証コードを入力してください',
		"register13": '利用規約を読み、同意しました',
		"register14": '利用規約を読んで確認してください',
		"register15": '携帯電話番号の形式が間違っています / 携帯電話番号が登録されています',
		"register16": '携帯電話認証コードが間違っています',
		"register17": 'メールアドレスを入力してください / メールアドレスの形式エラー',
		"register18": 'メール形式エラー',
		"register19": 'メール確認コードエラー',
		"register20": 'パスワードを6～16文字に設定してください',
		"register21": 'パスワード形式エラー',
		"register22": '2つのパスワードが一致していません。再入力してください',
		"register23": 'パスワードを入力してください',
		"register24": '登録成功！',
		"register25": '確認コードエラー',
	},
	recorder: {
		"recorder1": 'クラウドディスク',
		"recorder2": 'クラウドスペースの容量',
		"recorder3": '最近使用したファイル',
		"recorder331": 'ごみ箱',
		"recorder332": 'すべて削除',
		"recorder4": '名前',
		"recorder5": '音声の長さ',
		"recorder6": 'ファイルサイズ',
		"recorder7": '作成時間',
		"recorder8": '操作',
		"recorder9": 'クラウドスペースの説明',
		"recorder10": '音声',
		"recorder11": 'OCRファイル',
		"recorder12": '1. クラウドスペースは何に使用されますか？',
		"recorder13": 'レコーダーで録音した後、音声ファイルと文字起こしファイルをクラウドスペースにアップロードできます。レコーダーが手元になくても、クラウドスペースにアクセスして音声を確認できます。',
		"recorder14": '2. クラウドスペースへのアップロード方法',
		"recorder15": 'レコーダーの[マイファイル]に入り、対象のファイルを選択して長押しするとオプションが表示されます。「アップロード」をクリックして、ファイルをクラウドスペースにアップロードします。',
		"recorder16": '3. クラウドスペースのファイルを表示/管理する方法',
		"recorder17": 'Beibo公式サイトにログインし、「マイレコーダークラウドディスク」を選択すると、アップロードされたレコーダーファイルを確認できます。対象ファイルを選択することで、ダウンロード、削除などの操作が可能です。クラウドファイルを削除することで、クラウドストレージをクリーンアップできます！',
		"recorder18": '未転記',
		"recorder19": '概要を表示',
		"recorder20": '発言者',
		"recorder21": '発言者名を編集',
		"recorder22": '確認',
		"recorder23": 'ダウンロード',
		"recorder24": 'コンテンツのダウンロード:',
		"recorder25": 'ダウンロード設定:',
		"recorder26": '発言者を表示',
		"recorder27": 'キャンセル',
		"recorder28": 'リンクの共有',
		"recorder29": 'リンクを受け取った人なら誰でもアクセスできます。読み取りのみサポートされています。リンクは7日間有効です',
		"recorder30": 'リンクをコピー',
		"recorder31": 'スキャンしてすぐに表示',
		"recorder32": 'スマートな整理',
		"recorder33": '話者を区別',
		"recorder34": '話者の役割に応じて書き起こしテキストをインテリジェントに区別',
		"recorder35": 'インテリジェントな話し言葉の正規化',
		"recorder36": '助詞、繰り返し単語、一時停止単語を自動的にフィルタリング',
		"recorder37": '人間以外の音声フィルタリング',
		"recorder38": '再生中に人間の声とノイズのない音声を自動的にスキップ',
		"recorder39": '選択してください',
		"recorder40": 'ドキュメント',
		"recorder41": '音声',
		"recorder42": 'ドキュメント+オーディオ',
		"recorder43":'プロンプト',
		"recorder44":'この操作によりファイルが削除されます。続行しますか？',
		"recorder441":'この操作によりすべてのファイルが削除されます。続行しますか？',
		"recorder45":'OK',
		"recorder46":'キャンセル',
		"recorder47":'削除に成功しました！',
		"recorder48":'削除をキャンセルしました',
		"recorder49":'まだマークされていません',
		"recorder50":'保存中...',
		"recorder51":"ごみ箱",
	},
	personal: {
		"personal1": 'アカウント設定',
		"personal2": '個人情報',
		"personal3": 'アバター',
		"personal4": 'ファイルのアップロード',
		"personal5": 'JPG、JPEG、GIF、PNG形式に対応、2MB以内の画像に対応',
		"personal6": 'ニックネーム',
		"personal7": 'ニックネームを入力してください',
		"personal8": '性別',
		"personal9": 'Mr.',
		"personal10": 'Ms.',
		"personal11": '機密情報',
		"personal12": '誕生日',
		"personal13": '生年月日を選択してください',
		"personal14": '職業',
		"personal15": '職業を選択してください',
		"personal16": '職業を入力してください(オプション)',
		"personal17": '国',
		"personal18": '国を選択してください',
		"personal19": '保存',
		"personal20": '個人情報',
		"personal21": 'アカウントセキュリティ',
		"personal22": '2MB以内の画像のみサポートされます',
		"personal23": 'アップロードに成功しました！',
		"personal24": '変更に成功しました！',
		"personal25": 'アカウントセキュリティ',
		"personal26": 'ログインパスワード',
		"personal27": '変更',
		"personal28": 'メールアドレス',
		"personal29": '変更',
		"personal30": 'アカウントのキャンセル',
		"personal32": 'アカウントをキャンセルしてもよろしいですか？',
		"personal33": 'キャンセルすると、アカウント内のすべてのコンテンツが消去されます。慎重に操作してください。 ',
		"personal34": 'キャンセル',
		"personal35": '確認',
		"personal36": '認証',
		"personal37": '操作しているのがご本人様であることを確認するため、メールの確認コードで本人確認を完了してください',
		"personal38": 'メールアドレス',
		"personal39": '確認コード',
		"personal40": '確認コードを入力してください',
		"personal41": '次へ',
		"personal42": '新しいメールアドレスを設定',
		"personal43": 'メールアドレス',
		"personal44": '新しいメールアドレスを入力してください',
		"personal45": '確認コード',
		"personal46": '確認コードを入力してください',
		"personal47": '確認',
		"personal48": '新しいログインパスワードを設定',
		"personal49": '新規ログインパスワード',
		"personal50": '新しいパスワードを入力してください',
		"personal51": '新しいパスワードを確認',
		"personal52": '新しいパスワードをもう一度入力してください',
		"personal53": '確認',
		"personal54": '取得',
		"personal55": 'メールの形式エラー',
		"personal56": '変更に成功しました！',
		"personal57": 'パスワードは6～16文字に設定してください',
		"personal58": '入力した2つのパスワードが一致していません',
		"personal59": '変更に成功しました！',
		"personal60": 'ログアウトに成功しました！',
		"share_url": "リンク共有",
		"share_url_7_day": "共有リンクは7日間有効です。有効期限が切れるまでは、リンクを受け取った人は誰でもアクセスできます。",
		"share_audio": "音声録音",
		"share_trans_text": "文字起こし",
		"share_summny_text": "概要",
		"share_map": "マインドマップ",
		"share_url_pw": "アクセス暗号化",
		"share_random_pw": "パスワードはランダムに生成されました",
		"share_url_copy": "リンクをコピー",
		"share_link_pw": "アクセスパスワード",
		"share_copy_success": "コピーに成功しました！",
		"share_speaker": "スピーカー",
		"share_no_update_speaker": "スピーカーが空のため編集できません",
		"share_no_trans":"文字起こしがありません",
		"share_no_summny":"いいえ概要",
		"share_no_map":"マップコンテンツがありません",
		"share_trans_text_1":"転写",
		"share_summny_text_1":"概要",
		"share_map_1":"マップ",
		"share_save":"保存に成功しました",
		"share_no_map":"マップ画像が生成されませんでした",
		"share_update_text":"転写テキストを編集してください",
		"share_update_text2": "概要テキストを編集",
		"showLoading": "読み込み中...",
	}
}